module.exports = __webpack_public_path__ + "static/media/courses_card.3829c9f5.png";